module.exports = __webpack_public_path__ + "img/333_06.a8d48c52.gif";